import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import Header from "components/common_components/Header";
// import { Tabs } from "components/common_components/Tabs";
import MenuItem from "components/Menu/MenuItem";

const options = [
    { index: 0, label: "Users", path: "/settings/users", icon: "users" },
    { index: 1, label: "Business Hours", path: "/settings/business-hours", icon: "business-hours" },
    { index: 2, label: "Case Types", path: "/settings/types", icon: "types" },
    { index: 3, label: "Case Status", path: "/settings/status", icon: "status" },
    { index: 4, label: "Modules", path: "/settings/modules", icon: "modules" },
    { index: 5, label: "Contact Types", path: "/settings/contact-types", icon: "contact-type" },
    { index: 6, label: "File Locations", path: "/settings/file-locations", icon: "locations" },
    { index: 7, label: "Workflows", path: "/settings/flows", icon: "workflow" },
    { index: 8, label: "POS Categories", path: "/settings/pos/categories", icon: "pos" },
    { index: 9, label: "Documents Issuer", path: "/settings/documents-issuer", icon: "personal-info" },
    { index: 10, label: "Services", path: "/settings/services", icon: "list" },
    { index: 11, label: "System", path: "/settings/system-parameters", icon: "settings" },
];

function Settings({ children, history }) {
    const [selectedOption, setSelectedOption] = useState(options[0]);

    useEffect(() => {
        document.getElementsByTagName("main")[0].style.padding = "0";

        return () => {
            document.getElementsByTagName("main")[0].style.padding = "2rem";
        };
    }, []);

    useEffect(() => {
        const newSelectedOption = options.find((o) => history.location.pathname.startsWith(o.path));
        if (newSelectedOption) {
            setSelectedOption(newSelectedOption);
        }
    }, [history.location.pathname]);

    // function handleChange(_, newIndex) {
    //     history.push(options.find((o) => o.index === newIndex).path);
    // }

    // const renderTabLabel = (label) => {
    //     return label;
    // };

    return (
        <div className="settings">
            <div className="nav">
                <div className="nav__header nav-inner">
                    <Header title="Settings" />
                </div>
                <div className="nav__body">
                    <div className="nav-list">
                        {options.map((option) => (
                            <MenuItem
                                key={option.index}
                                id={option.index}
                                label={option.label}
                                icon={option.icon}
                                selected={option.index === selectedOption.index}
                                path={option.path}
                                onClick={() => setSelectedOption(option)}
                            />
                        ))}
                    </div>
                </div>
            </div>
            <div className="content">{children}</div>

            {/* <Tabs options={options} selectedOption={selectedOption} onChange={handleChange} renderTabLabel={renderTabLabel}>
                
            </Tabs> */}
        </div>
    );
}

export default withRouter(Settings);
